// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Service_wrap__3H32R","rightText":"Service_rightText__1OJ55","leftText":"Service_leftText__9eNf3"};